import * as React from "react";
const SvgProfilepicCamera = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <circle cx={12} cy={12} r={11} fill="#191919" stroke="#fff" strokeWidth={2} />
    <g fill="#fff">
      <path d="M7 10.189c0-.175 0-.263.007-.337a1.5 1.5 0 0 1 1.345-1.345c.074-.007.166-.007.35-.007.072 0 .107 0 .138-.002a1 1 0 0 0 .867-.625c.011-.028.022-.06.043-.123s.032-.095.043-.123a1 1 0 0 1 .867-.625C10.69 7 10.724 7 10.79 7h2.42c.066 0 .1 0 .13.002a1 1 0 0 1 .867.625c.011.028.022.06.043.123s.032.095.043.123a1 1 0 0 0 .867.625c.03.002.066.002.137.002.185 0 .277 0 .35.007a1.5 1.5 0 0 1 1.346 1.345c.007.074.007.162.007.337V14.1c0 .84 0 1.26-.163 1.581a1.5 1.5 0 0 1-.656.656c-.32.163-.74.163-1.581.163H9.4c-.84 0-1.26 0-1.581-.163a1.5 1.5 0 0 1-.656-.656C7 15.361 7 14.941 7 14.1z" />
      <path d="M12 14.25a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
    </g>
    <circle cx={12} cy={12.3} r={2} stroke="#191919" />
  </svg>
);
export default SvgProfilepicCamera;
